<template>
  <div class="visaEdit linear-main3">
    <ld-header
      class="font-lg"
      transparent
      white
      :z-index="0"
    >
      {{ visaSearchInfo.country }}
      <router-link
        class="white"
        to="/visa/OrderService"
        slot="right"
      >
        预订须知
      </router-link>
    </ld-header>

    <mescroll-vue
      class="wrapper"
      ref="mescroll"
      :down="down"
    >
      <DetailPanel
        class="round-sm mt5"
        :detail="visaSearchInfo.VisaDetail"
      >
        <van-row class="mt5">
          <van-col span="12">
            <label>
              出行日期：
            </label>
            {{ visaSearchInfo.tripDate }}
          </van-col>
          <van-col
            span="12"
            class="text-right main-color"
            @click="showTripDate = true"
          >
            更改日期 >
          </van-col>
        </van-row>

        <van-popup
          lock-scroll
          v-model="showTripDate"
          position="bottom"
        >
          <van-datetime-picker
            v-model="tripDateModel"
            type="date"
            :min-date="TRIPDATE_MIN"
            :max-date="TRIPDATE_MAX"
            @cancel="showTripDate = false"
            @confirm="tripDateSelect"
          />
        </van-popup>
      </DetailPanel>
      <!--出行人 -->
      <traver
        class="round-sm mt5"
        :traveler-list="travelerList"
        :title="$t('F006','出行人')"
        element=".visaEdit"
      />

      <!-- 差旅信息 -->
      <travel-info
        class="round-sm mt5"
        v-if="tripType == 1"
        ref="travelinfo"
        cplx="10913"
        element=".trEdit"
      />

      <!-- 寄回信息 -->
      <div
        class="round-sm mt5"
        v-if="visaSearchInfo.VisaDetail.showAddress"
      >
        <van-cell-group>
          <van-cell
            title="寄回信息"
            :border="false"
          />

          <van-cell
            is-link
            @click="$refs['address'].toggle()"
          >
            <van-icon
              class="van-cell__left-icon main-color"
              name="location"
              slot="icon"
            />
            <span slot="title">
              <span class="font16">{{ addressee }}</span>
              <span
                style="margin-left: 5px;"
                class="font12 gray"
              >{{ addresseePhone }}</span>
            </span>
            <span
              slot="label"
              class="font14 black"
            >
              {{ addresseeSite }}
            </span>
          </van-cell>

          <van-field
            label="快递费用"
            v-model="kdPayMethodName"
            is-link
            @click="showKdPayMethod = !showKdPayMethod"
            input-align="left"
            readonly
          />
        </van-cell-group>
      </div>

      <!-- 联系信息 -->
      <div class="round-sm mt5">
        <van-field
          :label="$t('D022','联系信息')"
          is-link
          :readonly="true"
          @click="$refs['linker'].toggle()"
        >
          <div slot="input">
            {{ linker.linkMan }} ({{ linker.linkTel }})
            <div class="font12 gray">
              {{ $t('D020','邮箱') }} ({{ linker.linkEmail }})
            </div>
          </div>
        </van-field>
      </div>
    </mescroll-vue>

    <!-- 底部导航 -->
    <ld-tabbar
      ref="tabbar"
      :price-list="priceList"
    >
      <van-row
        class="full-width bg-white shadow"
        type="flex"
        align="center"
        @click="$refs['tabbar'].toggle()"
      >
        <van-col
          span="12"
          :offset="1"
        >
          <span class="font10 red">&yen;</span>
          <span class="font24 red">{{ totolPrice }}</span>
          <span class="font10 gray">{{ $t('E017','共') }}{{ travelerList.length }}人</span>
          {{ $t('E006','明细') }}
          <van-icon
            name="arrow-up"
            class="vertical-middle"
            size="14"
          />
        </van-col>
        <van-col
          :offset="2"
          span="8"
        >
          <ld-button
            :loading="false"
            size="md"
            main
            @click.stop="book"
          >
            {{ $t('F560','提交订单') }}
          </ld-button>
        </van-col>
      </van-row>
    </ld-tabbar>
    
    <van-action-sheet
      v-model="showKdPayMethod"
      :actions="KdPayMethods"
      @select="methodSelect"
    />

    <!-- 选择收件地址 -->
    <ld-address
      ref="address"
      @selected="addressSelect"
    />

    <!-- 编辑联系人 -->
    <ld-edit-linker
      ref="linker"
      :data="linker"
    />
  </div>
</template>

<script>
import { Popup, Cell, CellGroup, Field, ActionSheet, DatetimePicker } from 'vant'
import { mapGetters } from 'vuex'
import { formatDate } from 'Utils/dateUtil'
import { changefocus } from 'Utils/tools'
import { getSysType } from 'CommonUtils/plus.js'

import DetailPanel from '../visaDetail/DetailPanel'
import traver from './traver'
import travelInfo from 'Components/travelInfo'
import ldButton from 'Common/ldButton'
import ldAddress from 'Components/ldAddress'
import ldTabbar from 'Components/ldTabbar/ldTabbar'
import ldEditLinker from 'Components/ldEditLinker'

import VisaOrder from 'Domain/entities/visa-order'
import VisaBookInterator, { KdPayMethods } from 'Domain/use-cases/visa-book-interactor'

export default {
  name: 'VisaEdit',
  components: {
    [Popup.name]: Popup,
    [ActionSheet.name]: ActionSheet,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Field.name]: Field,
    [DatetimePicker.name]: DatetimePicker,
    ldButton, ldTabbar, DetailPanel, traver, travelInfo, ldEditLinker, ldAddress,
    MescrollVue: () => import('mescroll.js/mescroll.vue')
  },
  data () {
    return {
      KdPayMethods,
      down:{ use: false },
      order: new VisaOrder(),
      showTripDate: false,
      tripDateModel: new Date(),
      TRIPDATE_MIN: new Date(),
      TRIPDATE_MAX: new Date('2099-12-30'),
      addressee: '',
      addresseePhone: '',
      addresseeSite: '',
      addressList: [],
      showKdPayMethod: false,
      kdPayMethod: KdPayMethods[1].key,
      kdPayMethodName: KdPayMethods[1].name,
      otherRemark: '',
      travelInfo: {},
      linker: {},
    }
  },
  async created () {
    this.tripDateModel = new Date(this.visaSearchInfo.tripDate)

    this.linker = {
      linkMan: this.userInfo.empInfo.empName,
      linkTel: this.userInfo.empInfo.phoneNumber || '',
      linkEmail: this.userInfo.empInfo.email || ''
    }
    this.addressee = this.userInfo.empInfo.empName
    this.addresseePhone = this.userInfo.empInfo.phoneNumber
  },
  methods: {
    changefocus,
    methodSelect(item) {
      this.showKdPayMethod = false
      this.kdPayMethodName = item.name
      this.kdPayMethod = item.key
    },
    tripDateSelect(item) {
      this.showTripDate = false
      this.visaSearchInfo.tripDate = formatDate(item).date
    },
    addressSelect (address) {
      this.addressee = address.recipient
      this.addresseePhone = address.phoneNumber
      this.addresseeSite = `${address.cName || ''} ${address.cityName || ''} ${address.addr || ''}`
    },
    ages(str) {
      if (str) {
        let r = str.match(/^(\d{1,4})(-|\/)(\d{1,2})\2(\d{1,2})$/)    
        if (r==null) return false    
        let d = new Date(r[1], r[3]-1, r[4])    
        if (d.getFullYear()==r[1]&&(d.getMonth()+1)==r[3]&&d.getDate()==r[4]) {  
          let Y = new Date().getFullYear()  
          return Y-r[1]  
        }
      } else {
        return 0
      }
    },
    async book() {
      /**
       * 差旅信息验证
       */
      if (this.tripType == 1) {
        let bl = this.$refs.travelinfo.result()
        if (bl === false) {
          return false
        } else {
          this.travelInfo = bl
        }
      }
      
      Object.assign(this.order, {
        'visaForm': this.visaSearchInfo.VisaDetail.visaForm,
        'orderFrom': getSysType(),
        'tripDate': this.visaSearchInfo.tripDate,
        'subjectCode': this.travelInfo.subjectCode,
        'projectCode': this.travelInfo.projectCode,
        'projectId': this.travelInfo.projectId,
        'projectName': this.travelInfo.projectName,
        'costCenterCode': this.travelInfo.costCenterCode,
        'costCenterId': this.travelInfo.costCenterId,
        'costCenterName': this.travelInfo.costCenterName,
        'ccsqdRemark': this.travelInfo.ccsqdRemark,
        'addressee': this.addressee,
        'addresseePhone': this.addresseePhone,
        'addresseeSite': this.addresseeSite,
        'kdPayMethod': this.kdPayMethod,
        'otherRemark': this.otherRemark,
        'tripType': this.tripType,
        'linkEmail': this.linker.linkEmail === '' ? '' : this.$options.filters.getEmail({ chName: '联系人', cardType: '2', email: this.linker.linkEmail }),
        'linkTel': this.linker.linkTel,
        'linkman': this.linker.linkMan,
        'peopleInfos': this.travelerList.map(travel => {
          return {
            empId: this.$options.filters.getId(travel),
            passengerName: this.$options.filters.getName(travel),
            passengerPhone: travel.phoneNumber,
            passengerType: travel.psgType || 1,
            idNo: travel.passport,
            sex: travel.sex,
            age: this.ages(travel.born),
            inputNo: travel.empNo
          }
        })
      })
      
      try {
        const { data = '' } = await VisaBookInterator.book(this.order)
        this.jump(data)
      } catch (error) {
        if (typeof error === 'string')	this.$dialog({ message: error })
      }
    },
    jump (orderId) {
      this.$router.push({ path: `/visa/cmp/${orderId}` })
      this.$store.commit('visa/CLEAR_VISASEARCHINFO')
    }
  },
  computed: {
    ...mapGetters({
      visaSearchInfo: 'visa/visaSearchInfo',
      travelerList: 'visa/travelerList',
      userInfo: 'userInfo',
      tripType: 'tripType',
    }),
    totolPrice () {
      const num = this.travelerList.length
      const SalePrice = this.visaSearchInfo.VisaDetail.salePrice
      const Kdf = (this.visaSearchInfo.VisaDetail.showAddress && this.kdPayMethod === KdPayMethods[1].key) 
        ? this.visaSearchInfo.VisaDetail.kdf : 0
      const ServiceFee = this.visaSearchInfo.VisaDetail.serviceFee
      
      return (SalePrice + ServiceFee) * num + Kdf
    },
    // 计算 `底部导航` 的价格明细
    priceList () {
      const num = this.travelerList.length
      const SalePrice = this.visaSearchInfo.VisaDetail.salePrice
      const Kdf = (this.visaSearchInfo.VisaDetail.showAddress && this.kdPayMethod === KdPayMethods[1].key) 
        ? this.visaSearchInfo.VisaDetail.kdf : 0
      const ServiceFee = this.visaSearchInfo.VisaDetail.serviceFee
      let rt = [
        { name: '价格', price: SalePrice, amount: num,	unit: '人' }
      ]

      if (this.visaSearchInfo.VisaDetail.showAddress && this.kdPayMethod === KdPayMethods[1].key) rt.push({ name: '快递费', price: Kdf })
      if (ServiceFee > 0) rt.push({ name: '服务费', price: ServiceFee, amount: num,	unit: '人' })

      return rt
    }
  }
}
</script>

<style lang="less">
.visaEdit {

  .wrapper {
    padding: 0 8px;
    height: calc(100vh - 100px);
  }

  h3 {
    margin: 0;
    margin-bottom: 8px;
  }

  .mt5 {
    margin-top: 5px;
  }

  .pad8 {
    padding: 8px;
  }

}
</style>
